export enum UserAccountType {
    User = 1,
    Transport = 2,
    Transfer = 3,
}

export const enumLabel = (value?: UserAccountType) => {
    switch (value) {
        case UserAccountType.User:
            return 'Личный счет';
        case UserAccountType.Transport:
            return 'Расчетный счет "Транспорт"';
        case UserAccountType.Transfer:
            return 'Расчетный счет "Переводы"';
        default:
            return '';
    }
};
